import { Box, BoxProps, Fade } from "@chakra-ui/react"

type Props = BoxProps & {
  isVisible: boolean
}

const ScrollShadow = ({
  isVisible,
  height = "46",
  background = "linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%)",
}: Props) => {
  return (
    <Fade in={isVisible} unmountOnExit>
      <Box w="100%" h={height} position="fixed" bottom={0} bg={background} pointerEvents="none" />
    </Fade>
  )
}

export default ScrollShadow
